import React from "react";
import "./style.css";

const InstallationVideos = () => {
  const INSTALLATION_VIDEOS = [
    { label: "Installation for two wheelers", ytVideoId: "dxs0gTqSY1Q" },
  ];

  return (
    <section className="panel-main installation-videos">
      <div className="installation-videos-conatiner">
        { INSTALLATION_VIDEOS.map((video, idx) => (
          <div key={idx} className="installation-video-card">
            <div className="video-box">
              <iframe className="installation-video-iframe" allowFullScreen={true} src={`https://www.youtube.com/embed/${video.ytVideoId}`} title={video.label}></iframe>
            </div>
            <p>{video.label}</p>
          </div>
        )) }
      </div>
    </section>
  )
}

export default InstallationVideos
